'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookContextPage = require('@narvar/nth-hook-context-page');

function useTrackQualityCarrierLogo(shipment) {
  const [clientCarrierLogo, setClientCarrierLogo] = React.useState();
  const {
    state: {
      carrier
    }
  } = nthHookContextPage.usePageContext();
  const ref = React.useRef(null);
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();

  // Force load image on client to track broken carrier logo image
  // https://github.com/facebook/react/issues/15446
  React.useEffect(() => {
    if (!shipment) return;
    setClientCarrierLogo(shipment.carrierLogoUrl);
  }, [shipment]);
  React.useEffect(() => {
    if (!ref.current) return;
    if (!shipment) return;
    const refCopy = ref.current;
    const handleError = () => {
      logEvent({
        eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        eventType: nthHookContextAnalytics.NarvarEventTypes.TRACK_QUALITY,
        pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        pageCarrierService: carrier,
        requestPage: shipment.carrierLogoUrl
      });
    };
    refCopy.addEventListener('error', handleError);
    return () => refCopy.removeEventListener('error', handleError);
  }, [ref, carrier, shipment, logEvent]);
  return {
    ref,
    clientCarrierLogo
  };
}

exports.useTrackQualityCarrierLogo = useTrackQualityCarrierLogo;
